export default __webpack_public_path__ + "static/media/500_ml.7ec00844.svg";